<template>
	<div class="tabWrapperSettings tabNotifications">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="notificationNotifications"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new notification"
				page-title="Notifications"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-notifications
				v-if="isViewNotifications"
				:dialogFlag="dialogFlag"
				:editNotifications="editNotifications"
				:items="notificationNotifications"

				@updateSave="onSaveViewNotifications"
				@updateClose="onCloseDialog('isViewNotifications')"
				@updateList="onUpdateList('notification')"
		></view-notifications>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabNotificationsTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewNotifications from "@/components/Settings/UserAccountSettings/ViewNotifications/ViewNotifications.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabNotifications",
	components: {
		DialogRemove,
		ViewNotifications,
		MainTable
	},
	computed: {
		...mapGetters([
			'editNotifications',
			'settingsNotifications',
			'notificationNotifications',
			'filtersNotifications',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabNotificationsTable;
		},
	},

	data: () => ({
		flag: TAB.NOTIFICATIONS,

		isViewNotifications: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountNotificationsList',
			'getAccountNotificationsEditModal',
			'deleteAccountNotifications',
			'onAccountNotificationsSave',
			'onAccountNotificationsEdit',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_INVENTORY, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'notification') {
				await this.getAccountNotificationsList();
			}
		},

		onClickButton({ key, item }, nameComponent) {

			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === this.flag && key === 'edit1') {
				this.accountNotificationsEdit();
			}
			if (nameComponent === this.flag && key === 'delete1') {
				const title = TITLE.REMOVE_INVENTORY;
				const text = TEXT.REMOVE_INVENTORY;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === this.flag) {
				const { id } = this.activeItem;
				await this.deleteAccountNotifications(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountNotificationsEdit() {
			this.dialogFlag = 'edit';
			const { id } = this.activeItem;
			console.log('%c [  id  ] ', 'color:#bada55', typeof id, id );
			await this.getAccountNotificationsEditModal(id);
			this.isViewNotifications = true;
		},
		async onCreate() {
			this.dialogFlag = 'add';
			await this.getAccountNotificationsEditModal();
			this.isViewNotifications = true;
		},
		async onSaveViewNotifications(args) {
			const { id } = args;

			if (id) {
				await this.onAccountNotificationsEdit(args);
			} else {
				await this.onAccountNotificationsSave(args);
			}

			await this.getAccountNotificationsList();
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountNotificationsList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

